import { createJSONStorage, persist } from 'zustand/middleware';

import { type CutoutRect, type CutoutRectComplex } from '@pkg/components/overlays/Backdrop/Backdrop.types.ts';
import { type OnboardStep } from '@pkg/types/app/onboarding.ts';

import { create } from '../helpers/create.ts';

import { stepsFtu } from './topics.ftu.ts';

interface State {
    showFTU: boolean;
    step: OnboardStep;
    steps: OnboardStep[];
    currentIndex: number;
    freeYat?: string;
    latestYat?: string;
    latestYatHidden?: boolean;
    cutout?: CutoutRect | CutoutRectComplex;
}
interface Actions {
    setShowFTU: (showFTU: boolean) => void;
    setSteps: (steps: OnboardStep[]) => void;
    setCurrentIndex: (idx: number) => void;
    setFreeYat: (freeYat?: string) => void;
    setLatestYat: (latestYat?: string) => void;
    setLatestYatHidden: (latestYatHidden?: boolean) => void;
    setCutout: (cutout: State['cutout']) => void;
    reset: () => void;
}

type FTUStoreState = State & Actions;

const initialState: State = {
    showFTU: false,
    currentIndex: 0,
    step: stepsFtu[0],
    steps: stepsFtu,
    cutout: undefined,
    freeYat: undefined,
    latestYat: undefined,
    latestYatHidden: true,
};

export const useFTUStore = create<FTUStoreState>()(
    persist(
        (set) => ({
            ...initialState,
            setShowFTU: (showFTU) => set({ showFTU }),
            setFreeYat: (freeYat) => set({ freeYat }),
            setCurrentIndex: (idx) =>
                set((state) => {
                    return { currentIndex: idx, step: state.steps[idx] };
                }),
            setCutout: (cutout) => set({ cutout }),
            setLatestYat: (latestYat) => set({ latestYat }),
            setLatestYatHidden: (latestYatHidden?: boolean) => set({ latestYatHidden }),
            setSteps: (steps: OnboardStep[]) => set({ steps }),
            reset: () => set({ ...initialState }),
        }),
        { name: 'ftu-store', storage: createJSONStorage(() => sessionStorage) },
    ),
);
